<template>

  <div class="address-list" v-if="list.length >0">

    <van-address-list @add="onAdd" v-model="chosenAddressId" :list="list" default-tag-text="默认" add-button-text="新增收货人地址" @edit="onEdit" />

  </div>
  <div v-else class="no-address">
    您还没有收货地址，马上添加吧！
    <van-button round type="danger" size="large" @click="onAdd">新增地址</van-button>
  </div>

</template>





<script>
import { AddressList } from "vant";
import { addressList } from "@/api/index";

import { Dialog } from "vant";
// import { Toast } from "vant";

export default {
  name: "addressManagement",
  components: { AddressList },
  data() {
    return {
      chosenAddressId: "1",
      list: [
        {
          id: "",
          name: "",
          tel: "",
          address: ""
        }
      ]
    };
  },
  mounted() {
    addressList().then(res => {
      if (res.data.errno == 0) {
        this.list = res.data.data;
        this.list.forEach(element => {
          element.address = element.detailedAddress;
          element.tel = element.mobile;
        });
      } else {
        Dialog.alert({
          title: "提示",
          message: res.data.errmsg
        });
      }
    });
  },
  methods: {
    onAdd() {
      //Toast('新增地址');
      //再此处push更多订单
      this.$router.push("/addressNew");
    },
    onEdit(item) {
      this.$router.push({
        path: "/addressNew",
        query: {
          id: item.id
        }
      });
    }
  }
};
</script>


<style scoped lang="scss">
.address-list {
  background: #f4f4f4;
  height: 100%;
}
.no-address {
  background: #fff;
  height: 100%;
  width: 100%;
  padding-top: 28rem;
  overflow: hidden;
  box-sizing: border-box;
  button {
    margin: 14rem auto 0;
  }
}
/deep/ .van-address-item .van-radio__icon:not(.van-radio__icon--checked) {
  visibility: inherit;
}
/deep/ .van-button {
  width: 90%;
  margin: 0 auto;
}
/deep/ .van-button--danger {
  background: #d6be93;
  border: 0;
}
/deep/ .van-address-item {
  .van-address-item__tag {
    background-image: linear-gradient(90deg, #fde58b 0%, #f8d268 100%);
    border-radius: 2px;
    font-family: PingFangSC-Regular;
    font-size: 1rem;
    color: #78470c;
    letter-spacing: 0;
    line-height: 1rem;
    padding: 0.3rem 0.6rem;
  }
  .van-address-item__edit {
    // border: 1.3px solid #a9a9a9;
    font-weight: 900;
    border: 0;
    font-size: 2rem;
  }
}
/deep/ .van-address-list {
  padding: 0;
}
/deep/ .van-address-item .van-radio__icon--checked .van-icon {
  background: #d6be93;
  border-color: #d6be93;
}
/deep/ .van-radio__icon--round {
  display: none;
}
/deep/ .van-address-item__name {
  display: flex;
  align-items: center;
  margin-bottom: 0.8rem;
  font-family: PingFangSC-Regular;
  font-size: 1.4rem;
  color: #424242;
  letter-spacing: 0;
  line-height: 1.4rem;
}
/deep/ .van-address-item__address {
  opacity: 0.5;
  font-family: PingFangSC-Regular;
  font-size: 1.2rem;
  color: #424242;
  letter-spacing: 0;
  line-height: 1.6rem;
}
</style>



// WEBPACK FOOTER //
// src/view/person/addressManagement.vue